export class Entity {}

export abstract class Ticket extends Entity {
  id = 0;
  operationDate?: Date = null;

  operationTypeId = 0;
  settlementTypeId = 0;
  settlementType = 0;
  statusId?: number = null;
  statusDescription?: string = null;
  workflowStartDate?: string = null;
  workflowEndDate?: string = null;
  statusRequiredRoles: [];
  DocumentType: number = null;
  accountManagerId: number = null;
  accountManagerName: string = null;
  accountManagerDocument: string = null;

  approvedGroupIds: number[];
  approvalGroupIds: number[];

  // TODO: padronizar boletas
  operationType: OperationType = null;

  ticketCutoffTypeId: number = null;
}

export class TicketHeader {
  OperationDate: Date = null;
  StatusId?: number = null;
  Portfolio: Portfolio = null;

  constructor() {}
}

export class Portfolio {
  name: string = null;
  document: string = null;
  bank: string = null;
  branch: string = null;
  account: string = null;
  clearingAccount = "";
  code = "";

  fundId: number = null;
  fundAccountId: number = null;
  sourceId: string = null;
  constructor() {}

  static Mock(): Portfolio {
    const m = new Portfolio();
    m.account = "111111";
    m.account = "123456";
    m.code = "123456";
    m.document = "60701190000104";
    m.name = "Guilherme Stenio";
    return m;
  }
}

export class Counterpart {
  constructor() {}
  name: string = null;
  document: string = null;
  clearingAccount: string = null; // Conta Clearing
  command: string = null;

  static Mock(): Counterpart {
    const m = new Counterpart();
    m.document = "60701190000104";
    m.name = "nome da contraparte";
    m.clearingAccount = "12345678";
    m.command = "12345";
    return m;
  }
}

export enum TicketType {
  Quota = 1,
  CETIP = 2,
  SELIC = 3,
  Contracted = 4,
  Futures = 5,
  SwapCetip = 6,
  Margin = 7,
  CurrencyTerm = 8,
  VariableIncome = 9,
  Transfer = 10,
  Loan = 11,
  Exchange = 12,
  Expenses = 13,
  StructuredOperations = 14,
  Liabilities = 15,
  StructuredOperationOrder = 16,
}

export enum LoadType {
  Fund = 1,
  Manager = 2,
  AccountsFund = 3,
  InvestedFund = 4,
  Calendar = 5,
  Ballast = 6,
}

export enum TicketStatus {
  Draft = -1,
  PendingAdmApproval = 1,
  CancelledByAdm = 2,
  AwaitingSettlement = 3,
  InActiveSettlement = 4,
  SettlementProcessed = 5,
  SettlementCancelled = 6,
}

/**
 * Mapeado conforme API.
 * @export
 * @enum {number}
 */
export enum OperationType {
  Application = 1,
  Redemption = 2,
  Deposit = 5,
  Withdrawal = 6,
  PurchasedCurrency = 7,
  SoldCurrency = 8,
  Transfer = 9,
  TED = 10,
  DOC = 11,
  FullRedemption = 12,
}

export enum OperationTypeQuota {
  Application = 1,
  Redemption = 2,
  FullRedemption = 12,
  Amortization = 4,
  Deposit = 5,
  Withdrawal = 6,
}

export enum OperationTypeLiabilities {
  Application = 1,
  Redemption = 2,
  FullRedemption = 12,
  Deposit = 5,
  Withdrawal = 6,
}

export enum FinancialSettlementType {
  CETIP = 1,
  CC = 2,
  DOC = 3,
  Internal = 4,
  Others = 99,
}

export enum SettlementType {
  CETIP = 1,
  TED = 2,
  Term = 3,
  InCash = 4,
  Sovereign = 5,
  OutCustody = 6,
  NoFinancial = 7,
  BankSlip = 8,
}

export enum DocumentType {
  CNPJ = 1,
  CPF = 2,
}

export enum FundType {
  CFF = "CFF",
  CFA = "CFA",
}

export enum WorkflowStatus {
  PendingAdmApproval = 1,
  CancelledByAdm = 2,
  WaitingSettlement = 3,
  InSettlement = 4,
  Settled = 5,
  CancelledBySettlement = 6,
  WaitingDetainerSettlement = 7,
  InDetainerSettlement = 8,
  CancelledByDetainer = 9,
  WaitingSettlementMiddle = 10,
  InMiddleSettlement = 11,
  CancelledByMiddle = 12,
  WaitingVoiceRecord = 13,
  InVoiceRecord = 14,
  CancelledByAccountManager = 15,
  Completed = 16,
  PendingAccountManagerApproval = 17,
  WaitingSantanderSettlement = 18,
  SettledSantander = 19,
  CancelledBySantander = 20,
  WaitingSettlementExternalClearing = 21,
  InSettlementExternalClearing = 22,
  ElectronicTransferReturn = 23,
  WaitingDistributionApproval = 24,
  CancelledByDistribution = 25,
  WaitingSettlementPilot = 26,
  SettlementPilot = 27,
  CancelledBySettlementPilot = 28,
  WaitingPassiveApproval = 29,
  CancelledByPassive = 30,
  InSettlementPilot = 31,
  UploadPendingApproval = 32,
  UploadCancelled = 33,
  UploadApproved = 34,
  StructuredPreAnalysis = 35,
  StructuredInAnalysis = 36,
  StructuredCancelledInPreAnalysis = 37,
  StructuredCancelledInAnalysis = 38,
  StructuredCompleted = 39,
  StructuredReservationAnalysis = 40,
  StructuredCancelledInReservationAnalysis = 41,
  StructuredFinalReviewerDecision = 42,
  StructuredReadyToOperate = 43,
  WaitingMinicomSettlement = 44,
  PendingControllershipApproval = 45,
  CancelledByControllership = 46,
}

/**
 *Mapeado conforme a API.
 * @export
 * @enum {number}
 */
export enum Currency {
  BRL = 1,
  USD = 2,
  EUR = 3,
  JPY = 4,
}

export enum LocalDetainer {
  BMF = 1,
  CBLC = 2,
  CETIP = 3,
  SEL = 4,
  Other = 99,
}

export enum Praca {
  Brasil = 1,
  EUA = 2,
}

export enum MarketType {
  FixedIncomePrivateAsset = 1,
  FixedIncomeGovernmentBond = 2,
  VariableIncome = 3,
  Cash = 4,
}

export enum EntryType {
  Register = 1,
  EarlySettlement = 2,
}

export enum MarginSettlmentType {
  SELIC = 1,
  B3 = 2,
  Cash = 3,
}

export enum InterestType {
  Exponencial = 1,
  Linear = 2,
}

export enum Clearing {
  Default = 1,
  BMF = 2,
  CBLC = 3,
  CETIP = 4,
  SELIC = 5,
  Outros = 99,
}

export enum DialogSize {
  Small = 1,
  Medium = 2,
  Big = 3,
}

export enum LoanTicketType {
  NewOperation = 1,
  EarlySettlement = 2,
  Renewal = 3,
}

export enum CounterpartType {
  PessoaFisica = 1,
  PessoaJuridica = 2,
}

export enum AssetCode {
  CDB = 1,
  LF = 2,
  DPGE = 3,
  LCI = 4,
  LCA = 5,
  RDB = 6,
  DEB = 7,
  CRI = 8,
  CRA = 9,
  CPR = 10,
  CCI = 11,
  CCE = 12,
  CCB = 13,
  LC = 14,
  NC = 15,
}
